import { makeAutoObservable } from 'mobx';
// import { mastercommunication } from './types';
import { v4 as uuid } from 'uuid';
import { toast } from 'react-toastify';
import { commSettingsForDynDash } from './service';

export default class CommunicationSettingStore {
  getmasterCommunication: any;
  // mastercommunicationInput: mastercommunication = {
  //   id: '',
  //   email: '',
  //   emailCopy: '',
  //   subject: '',
  //   message: '',
  //   attachment: '',
  //   model: '',
  //   modelSub: '',
  //   status: 0,
  //   userRolesId: '',
  //   masterId: '',
  //   isNotification: false,
  //   notifications: [],
  // };
  constructor() {
    makeAutoObservable(this);
  }
  setmasterCommunication = (params: any) => {
    const Scheme = {
      id: params.id || uuid(),
      email: null,
      emailCopy: null,
      subject: params.subject,
      attachment: params.attachment,
      model: params.model,
      modelSub: params.modelSub,
      status: params.status,
      message: params.message,
      userRolesId: params.userRolesId,
      masterId: params.masterId,
      isNotification: true,
      notifications: params.notifications,
    };
    this.getmasterCommunication = [Scheme];
  };
  updateCommunicationInput = (title: string, value: string) => {
    this.getmasterCommunication[0][title] = value;
  };

  communcation = async (
    id: string,
    params: any,
    method: string,
    params1?: any,
  ) => {
    try {
      if (method === 'masterApi') {
        const Response = await commSettingsForDynDash.showMaster(id);
        return Response;
        // this.getmasterCommunication = [Scheme];
      } else if (method === 'addApi') {
        let params = {};
        params = {
          id: uuid(),
          email: null,
          emailCopy: null,
          subject: '',
          message: '',
          attachment: '',
          model: '',
          modelSub: '',
          status: 0,
          userRolesId: '',
          masterId: params1?.masterId,
          isNotification: false,
          notifications: [],
        };

        await commSettingsForDynDash.addCommunication(params || params1);
        this.getmasterCommunication = [params || params1];
      } else if (method === 'showApi') {
        const response = await commSettingsForDynDash.showCommunication(id);
        this.setmasterCommunication(response.data);
        return response;
      } else if (method === 'updateApi') {
        await commSettingsForDynDash.updateCommunication(params);
        toast.success('Communication Updated Successfully...');
      } else if (method === 'deleteApi') {
        await commSettingsForDynDash.deleteCommunication(id);
      }
    } catch (error) {
      toast.error('Communication Failed...');
    }
  };
  notification = async (id: string, params: any, method: string) => {
    try {
      if (method === 'addApi') {
        await commSettingsForDynDash.addNotification(id, params);
      } else if (method === 'deleteApi') {
        await commSettingsForDynDash.deleteNotification(id);
        toast.success('Notification Deleted Successfully...');
      }
    } catch (error) {
      toast.error('Notification Failed ...');
    }
  };
}
